import React from "react";
import WordGridHowTo from "../puzzle-hidden-message/WordGridHowTo";

/** Route entry: `/howto/puzzle/word-search` */
export default function HowToWordGrid() {
    return <WordGridHowTo gridVariant="WORD_SEARCH" />;
}
